module.exports = __webpack_public_path__ + "static/media/09.e4e05c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/09.png
// module id = 180
// module chunks = 0